// import ApiService from '@/helpers/api.service';
import ApiService from "@/helpers/api.service.v6lite";

// const API = new ApiService();
const API = new ApiService();
const PEDDLR_WALLET_KYC_API = '/peddlr-wallet/kyc';

export const state = {
    userKycStatus: {
      "kycAcctType": "NoKYC",
      "kycAcctStatus": null,
      "kycStatus": null
    },
    userKycDetails: {},
    userKycPhotos: {},
    userKycActivityLogsList: [],
    userKycActivityLogsPageInfo: {
        total: 0
    },
    generatedKycUrl: '',
}

export const mutations = {
    UPDATE_USER_KYC_STATUS(state, data){
        state.userKycStatus = data;
    },
    UPDATE_USER_KYC_DETAILS(state, data){
        state.userKycDetails = data;
    },
    UPDATE_USER_KYC_PHOTOS(state, data){
      state.userKycPhotos = data;
    },
    UPDATE_USER_KYC_ACTIVITY_LOGS(state, data){
        state.userKycActivityLogsList = data;
    },
    UPDATE_USER_KYC_ACTIVITY_LOGS_PAGE_INFO(state, total){
        state.userKycActivityLogsPageInfo.total = total;
    },
    UPDATE_GENERATED_KYC_URL(state, data){
      state.generatedKycUrl = data;
    },
}

export const actions = {
    // use
    getUserKycPhotos(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${PEDDLR_WALLET_KYC_API}/user-kyc-photos`, params)
          .then(({ data }) => {
            context.commit('UPDATE_USER_KYC_PHOTOS', data.message);
            resolve();
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.message);
            reject();
          });
      });
    },
    getUserKycStatus(context, params){
        return new Promise((resolve, reject) => {
          API.post(`${PEDDLR_WALLET_KYC_API}/user-status`, params)
            .then(({ data }) => {
              context.commit('UPDATE_USER_KYC_STATUS', data.message);
              resolve();
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.message);
              reject();
            });
        });
    },
    testUserKycStatus(context,params){
        return new Promise(() => {
          context.commit('UPDATE_USER_KYC_STATUS', params);
        });
    },
    getUserKycDetails(context, params){
        return new Promise((resolve, reject) => {
          API.post(`${PEDDLR_WALLET_KYC_API}/user-kyc-details`, params)
            .then(({ data }) => {
              context.commit('UPDATE_USER_KYC_DETAILS', data.message);
              resolve();
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.message);
              reject();
            });
        });
    },
    
    getUserKycActivityLogs(context, params){
        return new Promise((resolve, reject) => {
          API.post(`${PEDDLR_WALLET_KYC_API}/user-kyc-activity-logs`, params)
            .then(({ data }) => {
              if (data.message == "No data retrieved.") {
                context.commit('UPDATE_USER_KYC_ACTIVITY_LOGS', []);
                context.commit('UPDATE_USER_KYC_ACTIVITY_LOGS_PAGE_INFO', 0);
              }
              else {
                context.commit('UPDATE_USER_KYC_ACTIVITY_LOGS', data.message.rows);
                context.commit('UPDATE_USER_KYC_ACTIVITY_LOGS_PAGE_INFO', data.message.pageInfo.total);
              }

              resolve();
            })
            .catch(({ response }) => {
              context.commit('SET_PROD_ERRORS', response.message);
              reject();
            });
        });
    },
    generateKycUrl(context, params){
      return new Promise((resolve, reject) => {
        API.post(`${PEDDLR_WALLET_KYC_API}/generate-kyc-url`, params)
          .then(({ data }) => {
            // Trust the backend status. On success the message is an object { url, ... }; on error it is a
            // plain string. Only reject on a non-ok status so a genuine success is never shown as "Failed".
            if ((data?.status ?? 'err') !== 'ok') {
              context.commit('UPDATE_GENERATED_KYC_URL', '');
              reject(typeof data?.message === 'string' ? data.message : (data?.message?.description || 'Failed to generate KYC URL.'));
              return;
            }
            const url = data.message && typeof data.message === 'object' ? (data.message.url || '') : '';
            context.commit('UPDATE_GENERATED_KYC_URL', url);
            resolve();
          })
          .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response?.message);
            reject();
          });
      });
    },
}